import AOL from '../../assets/images/cobrand/cobrand-aol-promo.jpg'
import CheapCruises from '../../assets/images/cobrand/cobrand-cheap-cruises-promo.jpg'
import Cruise411 from '../../assets/images/cobrand/cobrand-cruise411-promo.jpg'
import CruisesCom from '../../assets/images/cobrand/cobrand-cruises-com-promo.jpg'
import CruisesOnly from '../../assets/images/cobrand/cobrand-cruises-only-promo.jpg'
import Gathr from '../../assets/images/cobrand/cobrand-gathr-promo.jpg'
import LuxuryOnly from '../../assets/images/cobrand/cobrand-luxury-only-promo.jpg'
import Rakuten from '../../assets/images/cobrand/cobrand-rakuten-promo.jpg'
import RetailMeNot from '../../assets/images/cobrand/cobrand-retailmenot-promo.jpg'
import Swagbucks from '../../assets/images/cobrand/cobrand-swagbucks-promo.jpg'
import TopCashback from '../../assets/images/cobrand/cobrand-topcashback-promo.jpg'

type cobrandsType = {
  [key: string]: {
    alt: string
    src: string
  }
}

const cobrands: cobrandsType = {
  plaolacs: {
    alt: 'Hello AOL My Benefits Member',
    src: AOL
  },
  plaolgathr: {
    alt: 'Hello Gathr Member',
    src: Gathr
  },
  co46157: {
    alt: 'Welcome Rakuten member, thanks for choosing priceline',
    src: Rakuten
  },
  co2210202: {
    alt: 'Welcome RetailMeNot shopper, save on all your travel needs!',
    src: RetailMeNot
  },
  plchpcruises: {
    alt: 'CheapCruises.com Priceline Express Deal',
    src: CheapCruises
  },
  plc411: {
    alt: 'Cruise411 Priceline Express Deals',
    src: Cruise411
  },
  plcruises: {
    alt: 'Cruises Priceline Express Deals',
    src: CruisesCom
  },
  plconly: {
    alt: 'CruisesOnly Priceline Express Deal',
    src: CruisesOnly
  },
  pllux: {
    alt: 'Luxury Only Priceline Express Deal',
    src: LuxuryOnly
  },
  co5464610: {
    alt: 'Welcome TopCashback Member, earn cash back on your travel order',
    src: TopCashback
  },
  co5897557: {
    alt: 'Welcome Swagbucks member, thanks for choosing priceline',
    src: Swagbucks
  }
}

export default function getCobrandContent(refid: string | null) {
  return cobrands[refid?.toLowerCase() ?? 'plaolacs']
}
